import * as React from 'react';
import { Subtract } from 'utility-types';

export type ScreenContextProps = {
    screenWidth: number;
    screenHeight: number;
    screenRatio: string;
};

const initState: ScreenContextProps = {
    screenWidth: 0,
    screenHeight: 0,
    screenRatio: 'landscape'
};

export const ScreenContext = React.createContext<ScreenContextProps>(initState);

export class ScreenProvider extends React.Component<{}, ScreenContextProps> {

    static Inject = <P extends ScreenContextProps>(
        UnwrappedComponent: React.ComponentType<P>
    ) =>
        class WithScreen extends React.Component<
            Subtract<P, ScreenContextProps>
            > {
            render() {
                return (
                    <ScreenContext.Consumer>
                        {(context) => {
                            return <UnwrappedComponent {...this.props} {...context} />;
                        }
                        }
                    </ScreenContext.Consumer>
                );
            }
        }

    static Consumer: React.SFC<{ children: (context: ScreenContextProps) => React.ReactNode }> = (props) => {
        return <ScreenContext.Consumer>{props.children}</ScreenContext.Consumer>;
    }

    componentWillMount() {
        this._handleResize();
        window.addEventListener('resize', this._handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._handleResize);
    }
    constructor(props: {}) {
        super(props);
        this._handleResize = this._handleResize.bind(this);
        this.state = initState;
    }

    render() {
        return (
            <ScreenContext.Provider value={this.state}>
                {this.props.children}
            </ScreenContext.Provider>
        );
    }
    
    private _handleResize() {
        const screenW = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const screenH = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const ratio = screenW / screenH;
        const railmode = ratio >= 0.83 ? 'landscape' : 'portrait';

        this.setState(prev => ({ screenWidth: screenW, screenHeight: screenH, screenRatio: railmode }));
    }
}

export default Screen;


// WEBPACK FOOTER //
// ./src/_context/Screen.tsx